var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var resolvePaths = require('./utils/resolvePaths');

var circularize = require('./utils/circularize');

var createJob = require('./createJob');

var _require = require('./utils/log'),
    log = _require.log;

var getId = require('./utils/getId');

var _require2 = require('./constants/config'),
    defaultOEM = _require2.defaultOEM;

var _require3 = require('./worker/node'),
    defaultOptions = _require3.defaultOptions,
    spawnWorker = _require3.spawnWorker,
    terminateWorker = _require3.terminateWorker,
    onMessage = _require3.onMessage,
    loadImage = _require3.loadImage,
    send = _require3.send;

var workerCounter = 0;

module.exports = function () {
  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var id = getId('Worker', workerCounter);

  var _resolvePaths = resolvePaths(_objectSpread(_objectSpread({}, defaultOptions), _options)),
      logger = _resolvePaths.logger,
      errorHandler = _resolvePaths.errorHandler,
      options = _objectWithoutProperties(_resolvePaths, ["logger", "errorHandler"]);

  var resolves = {};
  var rejects = {};
  var worker = spawnWorker(options);
  workerCounter += 1;

  var setResolve = function setResolve(action, res) {
    resolves[action] = res;
  };

  var setReject = function setReject(action, rej) {
    rejects[action] = rej;
  };

  var startJob = function startJob(_ref) {
    var jobId = _ref.id,
        action = _ref.action,
        payload = _ref.payload;
    return new Promise(function (resolve, reject) {
      log("[".concat(id, "]: Start ").concat(jobId, ", action=").concat(action));
      setResolve(action, resolve);
      setReject(action, reject);
      send(worker, {
        workerId: id,
        jobId: jobId,
        action: action,
        payload: payload
      });
    });
  };

  var load = function load(jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'load',
      payload: {
        options: options
      }
    }));
  };

  var writeText = function writeText(path, text, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'writeFile',
        args: [path, text]
      }
    }));
  };

  var readText = function readText(path, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'readFile',
        args: [path, {
          encoding: 'utf8'
        }]
      }
    }));
  };

  var removeFile = function removeFile(path, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: 'unlink',
        args: [path]
      }
    }));
  };

  var FS = function FS(method, args, jobId) {
    return startJob(createJob({
      id: jobId,
      action: 'FS',
      payload: {
        method: method,
        args: args
      }
    }));
  };

  var loadLanguage = function loadLanguage() {
    var langs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'eng';
    var jobId = arguments.length > 1 ? arguments[1] : undefined;
    return startJob(createJob({
      id: jobId,
      action: 'loadLanguage',
      payload: {
        langs: langs,
        options: options
      }
    }));
  };

  var initialize = function initialize() {
    var langs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'eng';
    var oem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOEM;
    var jobId = arguments.length > 2 ? arguments[2] : undefined;
    return startJob(createJob({
      id: jobId,
      action: 'initialize',
      payload: {
        langs: langs,
        oem: oem
      }
    }));
  };

  var setParameters = function setParameters() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var jobId = arguments.length > 1 ? arguments[1] : undefined;
    return startJob(createJob({
      id: jobId,
      action: 'setParameters',
      payload: {
        params: params
      }
    }));
  };

  var recognize = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(image) {
      var opts,
          jobId,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              jobId = _args.length > 2 ? _args[2] : undefined;
              _context.t0 = startJob;
              _context.t1 = createJob;
              _context.t2 = jobId;
              _context.next = 7;
              return loadImage(image);

            case 7:
              _context.t3 = _context.sent;
              _context.t4 = opts;
              _context.t5 = {
                image: _context.t3,
                options: _context.t4
              };
              _context.t6 = {
                id: _context.t2,
                action: 'recognize',
                payload: _context.t5
              };
              _context.t7 = (0, _context.t1)(_context.t6);
              return _context.abrupt("return", (0, _context.t0)(_context.t7));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function recognize(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getPDF = function getPDF() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Tesseract OCR Result';
    var textonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var jobId = arguments.length > 2 ? arguments[2] : undefined;
    return startJob(createJob({
      id: jobId,
      action: 'getPDF',
      payload: {
        title: title,
        textonly: textonly
      }
    }));
  };

  var detect = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(image, jobId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = startJob;
              _context2.t1 = createJob;
              _context2.t2 = jobId;
              _context2.next = 5;
              return loadImage(image);

            case 5:
              _context2.t3 = _context2.sent;
              _context2.t4 = {
                image: _context2.t3
              };
              _context2.t5 = {
                id: _context2.t2,
                action: 'detect',
                payload: _context2.t4
              };
              _context2.t6 = (0, _context2.t1)(_context2.t5);
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t6));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function detect(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var terminate = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (worker !== null) {
                /*
                await startJob(createJob({
                  id: jobId,
                  action: 'terminate',
                }));
                */
                terminateWorker(worker);
                worker = null;
              }

              return _context3.abrupt("return", Promise.resolve());

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function terminate() {
      return _ref4.apply(this, arguments);
    };
  }();

  onMessage(worker, function (_ref5) {
    var workerId = _ref5.workerId,
        jobId = _ref5.jobId,
        status = _ref5.status,
        action = _ref5.action,
        data = _ref5.data;

    if (status === 'resolve') {
      log("[".concat(workerId, "]: Complete ").concat(jobId));
      var d = data;

      if (action === 'recognize') {
        d = circularize(data);
      } else if (action === 'getPDF') {
        d = Array.from(_objectSpread(_objectSpread({}, data), {}, {
          length: Object.keys(data).length
        }));
      }

      resolves[action]({
        jobId: jobId,
        data: d
      });
    } else if (status === 'reject') {
      rejects[action](data);

      if (errorHandler) {
        errorHandler(data);
      } else {
        throw Error(data);
      }
    } else if (status === 'progress') {
      logger(data);
    }
  });
  return {
    id: id,
    worker: worker,
    setResolve: setResolve,
    setReject: setReject,
    load: load,
    writeText: writeText,
    readText: readText,
    removeFile: removeFile,
    FS: FS,
    loadLanguage: loadLanguage,
    initialize: initialize,
    setParameters: setParameters,
    recognize: recognize,
    getPDF: getPDF,
    detect: detect,
    terminate: terminate
  };
};